module.exports = __webpack_public_path__ + "img/horizontal_7_6_6005.51eda794.png";